export enum Views {
  GRID_VIEW = 'grid',
  LIST_VIEW = 'list'
}
